import React, { useState, useEffect } from "react";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import Select from "react-select";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { useNavigate } from "react-router-dom";
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { ReactComponent as DeleteIcon } from "../../img/trashicon.svg";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";

export default function DaftarPemasok() {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [errorData, setErrorData] = useState(null);
  const [userId, setUserId] = useState("");
    const navigate = useNavigate();
      const [searchQuery, setSearchQuery] = useState(""); // State for search input

  // Fetch ingredient categories

  const [formData, setFormData] = useState({
    name: "",
    regency_id: "",
    address: "",
    pic: "",
    phone: "",
    email: "",
    description: "",
    admin_id: userId,
    category_count: 0, // Initial category count
    categories: [], // Array to store selected categories
  }); 
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

    const fetchData = async () => {
  // Fetch supplier data
      try {
        const response = await instance2.get("supplier");
        setData(response.data); // Access the appropriate field in the response
      } catch (err) {
        setErrorData(err.message);
      } finally {
        setLoadingData(false);
      }
    };
  
  useEffect(() => {
    fetchData();
  }, []);
  

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();

    return (
      (item.regency_name?.toLowerCase().includes(searchValue) || false) ||
      (item.supplier_name?.toLowerCase().includes(searchValue) || false) ||
      (item.phone?.toLowerCase().includes(searchValue) || false) 
    );
  });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
  
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePreviousPage = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
    };
  
    const handleNextPage = () => {
      if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
  
    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }

// --- STATE ---
const [confirmOpen, setConfirmOpen] = useState(false);
const [resultOpen, setResultOpen] = useState(false);
const [resultTitle, setResultTitle] = useState("");
const [resultMsg, setResultMsg] = useState("");
const [blockingNames, setBlockingNames] = useState([]);
const [deleting, setDeleting] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null);

// open confirm dialog
const onClickDelete = (item) => {
  setDeleteTarget(item);
  setConfirmOpen(true);
};

// confirm deletion -> call API
const confirmDeleteNow = async () => {
  if (!deleteTarget) return;
  setDeleting(true);

  try {
    const res = await instance2.delete(`/supplier/${deleteTarget.id}`);

    // prefer backend status field if present
    const httpStatus = res?.status;

    if (httpStatus === "OK" || httpStatus === 200) {
      // ✅ success
      setConfirmOpen(false);
      setResultTitle("Sukses");
      setResultMsg("Data telah terhapus.");
      setBlockingNames([]);
      setResultOpen(true);
      fetchData(); // Refresh table
      return;
    }

    // Non-OK but not thrown (rare): treat as blocked/error payload
    const raw = Array.isArray(res?.data?.data)
      ? res.data.data
      : Array.isArray(res?.data)
      ? res.data
      : [];
    const names = raw.map((x) => x?.name).filter(Boolean);

    setConfirmOpen(false);
    setResultTitle("Tidak Bisa Dihapus");
    setResultMsg("Mohon hapus data makanan di bawah terlebih dahulu:");
    setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
    setResultOpen(true);
  } catch (e) {
    const httpStatus = e?.response?.status;
    const apiStatus  = e?.response?.data?.status;

    // 🔴 500 (or backend status "ERROR"): show blocker dialog + names list
    if (httpStatus === 500 || apiStatus === "ERROR") {
      const raw = Array.isArray(e?.response?.data?.data)
        ? e.response.data.data
        : Array.isArray(e?.response?.data)
        ? e.response.data
        : [];
      const names = raw.map((x) => x?.name).filter(Boolean);

      setConfirmOpen(false);
      setResultTitle("Tidak Bisa Dihapus");
      setResultMsg("Mohon hapus data di bawah terlebih dahulu:");
      setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
      setResultOpen(true);
    } else {
      // generic/unexpected error
      setConfirmOpen(false);
      setResultTitle("Gagal");
      setResultMsg(e?.response?.data?.message || "Terjadi kesalahan. Coba lagi.");
      setBlockingNames([]);
      setResultOpen(true);
    }
  } finally {
    setDeleting(false);
    setDeleteTarget(null);
  }
};

  return (
    <div className="p-4">
  

  {/* Table Section */}
  
  <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
      <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Pemasok</h2>
      <button
        type="button"
        onClick={() => navigate("/tambahpemasok")}
        className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
      >
        Tambah Pemasok
      </button>
    </div>
  {loadingData && <p>Loading...</p>}
  {errorData && <p className="text-red-500">{errorData}</p>}
  {!loadingData && data.length === 0 && <p>No data available</p>}
  {!loadingData && data.length > 0 && (
    <>  
    {/* Search Bar */}
          <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
            <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
              <MagnificationLogo className="h-6 w-6" />
              <VerticalLine className="mx-1" />
              <input
                type="text"
                placeholder="Telusuri data berdasarkan kota, nama pemasok, atau nomor telepon"
                className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                style={{
                  width: `${"Telusuri data berdasarkan kota, nama pemasok, atau nomor telepon".length}ch`,
                }}
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
            </div>
          </div>
      <table className="table-fixed w-full border-gray-300">
        <thead>
          <tr className="bg-white">
            <th className="w-[50px] border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tl-[15px] text-center text-xxs md:text-xxs lg:text-base">
              No
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
              Kota
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
              Nama Pemasok
            </th>
            {/* <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Kategori Utama
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Alamat
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Narahubung
            </th> */}
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
              Telepon
            </th>
            {/* <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Deskripsi
            </th> */}
                <th
                  className="border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base"
                >
                  Aksi
                </th>
          </tr>
        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
            key={item.id}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
              <td className="px-2 sm:px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
              {index + 1 + (currentPage - 1) * itemsPerPage}
              </td>
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.regency_name}
              </td>
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.supplier_name}
              </td>
              {/* <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.category_name || "-"}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.address}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.pic}
              </td> */}
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.phone}
              </td>
              {/* <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.description}
              </td> */}
                                <td className="px-4 py-2 text-center">
                                <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                     onClick={() => navigate(`/editpemasok?id=${item.id}`)}
                                  >
                                    <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                                  </button>

                                  <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                     onClick={() => navigate(`/lihatpemasok?id=${item.id}`)}
                                  >
                                    <EyeIcon className="w-5 h-5 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                                  </button>
                                                      {/* <button
                                                        className="text-gray-500 p-2 rounded hover:text-red-500"
                                                        onClick={() => onClickDelete(item)}
                                                      >
                                                        <DeleteIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                                                      </button> */}
                                </td>
            </tr>
          ))}
        </tbody>
      </table>

         
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
    </>
  )}
    {/* Confirm dialog delete */}
  <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Konfirmasi Hapus</DialogTitle>
        <DialogDescription>
          Hapus <b>{deleteTarget?.supplier_name || "item ini"}</b>? Tindakan tidak dapat dibatalkan.
        </DialogDescription>
      </DialogHeader>
  
      <DialogFooter className="gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded border"
          onClick={() => setConfirmOpen(false)}
          disabled={deleting}
        >
          Batal
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-60"
          onClick={confirmDeleteNow}
          disabled={deleting}
        >
          {deleting ? "Menghapus..." : "Ya, Hapus"}
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  
  {/* Result / Info dialog */}
  <Dialog open={resultOpen} onOpenChange={setResultOpen}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{resultTitle}</DialogTitle>
        <DialogDescription>{resultMsg}</DialogDescription>
      </DialogHeader>
  
      {blockingNames.length > 0 && (
        <div className="mt-3 text-sm">
          <ul className="list-disc pl-5 space-y-1">
            {blockingNames.map((n, i) => (
              <li key={`${n}-${i}`}>{n}</li>
            ))}
          </ul>
        </div>
      )}
  
      <DialogFooter>
        <button
          type="button"
          className="px-4 py-2 rounded bg-gray-200"
          onClick={() => setResultOpen(false)}
        >
          Tutup
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</div>

  );
}
